import RegisterPage from './register-page'
export default RegisterPage;